export class ChecklistaTexts {
    static readonly texts = {
        addGrupp: "Lägg till grupp",
        editFraga: "Redigera fråga"
    };
}
